export default __webpack_public_path__ + "static/media/ngo-a036-example.4e705c7b.jpg";